export default __webpack_public_path__ + "static/char-s-18-jp-2753e053ed018af4752240948a09c4aa.png";